import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.visibleButton)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          ref: "refButtonDetails",
          icon: "pi pi-bell",
          severity: _ctx.notice,
          rounded: "",
          "aria-label": "Notification",
          class: "details-development__button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visibleSidebar = true))
        }, null, 8, ["severity"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Sidebar, {
      visible: _ctx.visibleSidebar,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visibleSidebar) = $event)),
      position: "bottom",
      style: {"height":"90vh"}
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info, (valueInfo, indexValueInfo) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: indexValueInfo }, [
            _createElementVNode("h4", null, _toDisplayString(valueInfo.title), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valueInfo.observation, (valueObservation, indexObservation) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: indexObservation }, [
                _createElementVNode("b", null, _toDisplayString(valueObservation.label) + ":", 1),
                (typeof valueObservation.text === 'object')
                  ? (_openBlock(), _createElementBlock("pre", _hoisted_1, "        " + _toDisplayString(valueObservation.text) + "\n        ", 1))
                  : (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      innerHTML: valueObservation.text,
                      class: "mb-1"
                    }, null, 8, _hoisted_2))
              ], 64))
            }), 128)),
            (valueInfo.values)
              ? (_openBlock(), _createBlock(_component_DataTable, {
                  key: 0,
                  stripedRows: "",
                  value: valueInfo.values,
                  class: "p-datatable-sm"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valueInfo.columns, (valueColumn, valueColumnIndex) => {
                      return (_openBlock(), _createBlock(_component_Column, {
                        key: valueColumnIndex,
                        field: valueColumn.field,
                        header: valueColumn.header
                      }, null, 8, ["field", "header"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["value"]))
              : _createCommentVNode("", true),
            _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}